/**
 * Compile a `prompt_skeleton` against the user's collected field values.
 *
 * Supports two slot forms:
 *   {{field_key}}            → string value or fallback / "" if missing.
 *   {{field_key|comma-list}} → for arrays, joined with ", ".
 *
 * `fields` is the WizardConfig.fields array, used to look up
 * `skip_fallback` so a skipped business-name renders as a graceful
 * generic phrase instead of an empty hole in the prompt.
 */
export function compilePrompt(skeleton, fieldValues = {}, fields = []) {
  if (!skeleton) return "";
  const fallbackByKey = {};
  fields.forEach((f) => {
    if (f.skip_fallback) fallbackByKey[f.key] = f.skip_fallback;
  });
  return skeleton.replace(/\{\{\s*([a-zA-Z0-9_]+)(\s*\|\s*comma-list)?\s*\}\}/g, (_, key) => {
    const raw = fieldValues[key];
    if (raw === undefined || raw === null || raw === "") {
      return fallbackByKey[key] || "";
    }
    if (Array.isArray(raw)) return raw.join(", ");
    return String(raw);
  });
}
